import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Card,
  InputAdornment,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Box,
} from "@mui/material";
import LOCALE from "../../../config/en-us.json";
import constants from "../../../config/constants.json";
import commonStyles from "../../../App.module.scss";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import FormControl from "@mui/material/FormControl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LocalizationProvider } from "@mui/x-date-pickers";
import cartIcon from "../../../assets/svg/Cart.svg";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ValidationError, number, object, string } from "yup";
import styles from "../devoteeService.module.scss";
import dayjs from "dayjs";
import {
  CustomSelect,
  CustomMenuItem,
  StyledDateContainer,
  CustomInputLabel,
  CustomTextFeild,
  CommonButton,
  CustomRequiredInputLabel,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomBadge,
  CustomLeftIcon,
  CommonOutlinedButton,
} from "../../common/StyledComponents/StyledFields";
import {
  apiRequest,
  catchErrorMessageHandler,
  getDevoteeId,
} from "../../../infrastructure/backendService";
import HcccTimePicker from "../../common/customTimePicker/hcccTimePicker";
import {
  cartItemListProps,
  hallRentalListProps,
} from "../../../infrastructure/GlobalContextProvider";
import { isNil, isNumber } from "lodash";
import apiPath from "../../../config/apiPaths.json";
import toast, { Toaster } from "react-hot-toast";
import ManagerCartItemsComponent from "../../managerDashboard/managerCartItems/managerCartItems";
import { useLocation, useNavigate } from "react-router-dom";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import { handleHallTimeChangeSetErrors } from "../../common/handleTimeChangeSetErrors";
import { useAppDispatch, useAppSelector } from "../../../app/hook";
import {
  addHallBookingDetails,
  fetchHallList,
} from "../../../features/hallBookingSlice";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import ConfirmationDialog from "../../common/CofirmationDialog/ConfirmationDialog";

interface HallRentalProps {
  onBackClick: () => void;
  setShowHallScheduleScreen: any;
}

interface ErrorMessageTypes {
  name: string;
  nameOfHall: string;
  noOfHours: string;
  description: string;
  date: string;
  bookingTime: string;
  amount: string;
}

interface formDataTypes {
  name: string;
  nameOfHall: string;
  noOfHours: string;
  date: string;
  amount: number;
  description: string;
  hours: number;
  minutes: number;
  bookingTime: string;
}

const DevoteeHallBooking = (props: HallRentalProps) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigationState = location.state;
  const { hallList } = useAppSelector((state) => state.hallBooking);
  // for ASP modifications
  const hallId = navigationState?.hallId;
  const start_date = dayjs(navigationState?.start_date, "MM-DD-YYYY");
  const completeDate = start_date?.isValid()
    ? start_date.format("MM-DD-YYYY")
    : "";
  const start_time = navigationState?.start_time;
  const getHours = navigationState?.hallHours;
  const getMinutes = navigationState?.hallmins;
  const getAmount = navigationState?.hallAmount;
  const description = navigationState?.halldesc;
  const gethallName = hallList.find((hall) => hall.id === parseInt(hallId, 10));
  const isHallScheduled = navigationState?.isHallScheduled || false;
  //
  const [showList, setShowList] = useState<boolean>(false);
  const [formData, setFormData] = useState<formDataTypes>({
    name: getDevoteeId()?.userId?.toUpperCase() || "",
    nameOfHall: gethallName?.name || "",
    noOfHours: `${parseInt(getHours, 10)} ${parseInt(getMinutes, 10)}` || "",
    date: completeDate || "",
    description: description || "",
    hours: parseInt(getHours, 10) || 0,
    amount: 0,
    minutes: parseInt(getMinutes, 10) || 0,
    bookingTime: start_time || "",
  });
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    name: "",
    nameOfHall: "",
    noOfHours: "",
    description: "",
    date: "",
    bookingTime: "",
    amount: "",
  });
  const [cartItemIds, setCartItemIds] = useState<any[]>([]);
  const [totalDonationAmount, setTotalDonationAmount] = useState<number>(0);
  const [cartItemsList, setcartItemsList] = useState<cartItemListProps[]>([]);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  const getHallAndAmountByHallId = (
    hallId: string | number,
    isScheduledData = false
  ) => {
    const selectedHall = hallList.find(
      (item: hallRentalListProps) => item.id === Number(hallId)
    );
    if (!isNil(selectedHall)) {
      let extraHoursFee = 0;
      if (isScheduledData && hallId === selectedHall?.id) {
        const extraHours =
          getHours + getMinutes / 60 - selectedHall?.minimumHours;
        extraHoursFee =
          extraHours > 0 ? extraHours * selectedHall?.hourlyFee : 0;
        setAmountBreakDown({
          securityDeposit: navigationState?.securityDeposit,
          setupAndCleaningFee: navigationState?.setupAndCleaningFee,
          totalHoursFee: (getHours + getMinutes / 60) * selectedHall?.hourlyFee,
        });
      } else {
        setAmountBreakDown({
          securityDeposit: selectedHall?.securityDeposit,
          setupAndCleaningFee: selectedHall?.setupAndCleaning,
          totalHoursFee: selectedHall?.minimumFee,
        });
      }
      const money =
        selectedHall?.securityDeposit +
        selectedHall?.setupAndCleaning +
        selectedHall?.minimumFee +
        extraHoursFee;
      return { selectedHall, money };
    }
    return;
  };

  const [hallDetails, sethallDetails] = useState({
    capacity: "",
    minHours: "",
    minFee: "",
    setupAndCleaning: "",
    securityDeposit: "",
    cancellationFee: "",
    hourlyFee: 0,
    amount: 0,
    hallId: !isNil(hallId) ? parseInt(hallId, 10) : 0,
    defaultAmount: 0,
  });
  const [isHoursValid, setIsHoursValid] = useState(true);
  const [totalAmount, setTotalAmount] = useState<number | string>(
    parseInt(getAmount, 10) || 0
  );
  const [amountBreakDown, setAmountBreakDown] = useState<{
    totalHoursFee: any;
    securityDeposit: any;
    setupAndCleaningFee: any;
  }>({
    totalHoursFee: 0,
    securityDeposit: 0,
    setupAndCleaningFee: 0,
  });

  const [totalHours, setTotalHours] = useState<number>(
    parseInt(getMinutes, 10) / 60 + parseInt(getHours, 10) || 0
  );
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [showHallSchedule, setShowHallSchedule] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (
      parseInt(hallId, 10) !== hallDetails.hallId &&
      hallDetails.minHours !== ""
    ) {
      setFormData({
        ...formData,
        minutes: 0,
        hours: parseInt(hallDetails.minHours, 10),
        noOfHours: `${hallDetails.minHours}:${formData.minutes}`,
        nameOfHall: gethallName?.name || "",
      });
    }
  }, [hallDetails]);

  useEffect(() => {
    setFormData({
      ...formData,
      minutes: parseInt(getMinutes, 10) || 0,
      hours: parseInt(getHours, 10) || 0,
      noOfHours: `${parseInt(getHours, 10) || 0}:${
        parseInt(getMinutes, 10) || 0
      }`,
      nameOfHall: gethallName?.name || "",
    });
  }, [getMinutes, getHours]);

  useEffect(() => {
    dispatch(fetchHallList())
      .then((res: any) => {
        if (res?.meta?.requestStatus === "rejected") {
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(res?.payload)}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        }
      })
      .catch((err: any) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  useEffect(() => {
    getCartItems();
  }, []);

  const getCartItems = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cartItems,
      includeToken: true,
      params: {
        username: getDevoteeId()?.userId,
      },
    })
      .then((res) => {
        setShowList(false);
        const cartItemObjects = res.data.bookedItemInCart.map(
          (item: cartItemListProps) => ({
            itemId: item.id, // Create an object with itemId as the key and item's id as the value
          })
        );
        setcartItemsList(res.data.bookedItemInCart);
        setCartItemIds(cartItemObjects);
        setTotalDonationAmount(res.data.totalAmount);
      })
      .catch((err) => {
        console.log(err);
        setShowList(false);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const validationSchema = object().shape({
    name: string().required("Name is required"),
    // nameOfHall: string().required("Hall name is required"),
    noOfHours: string().required("Number of hours is required"),
    date: string().required("Date is required"),
    description: string().required("Description is required"),
    bookingTime: string().required("Booking Time is required"),
    // amount:  number()
    // .required("Donation amount is required")
    // .min(1, "Minimum donation amount is 1")
    // .transform((value, originalValue) => {
    //   return originalValue === "" ? undefined : value;
    // })
  });

  const validateDonationSchema = number()
    .required("Donation amount is required")
    .min(1, "Minimum donation amount is 1")
    .transform((value, originalValue) => {
      return originalValue === "" ? undefined : value;
    });

  const hoursList = [
    { label: 0 },
    { label: 1 },
    { label: 2 },
    { label: 3 },
    { label: 4 },
    { label: 5 },
    { label: 6 },
    { label: 7 },
    { label: 8 },
    { label: 9 },
    { label: 10 },
    { label: 11 },
    { label: 12 },
  ];

  const minutesList = [
    { label: 0 },
    { label: 15 },
    { label: 30 },
    { label: 45 },
    { label: 60 },
  ];

  const sendRequestApi = () => {
    setOpenConfirmationDialog(false);
    const reqBody = {
      onBehalfOfUsername: formData.name.toUpperCase(),
      bookingDate: formData.date,
      bookingTime: formData.bookingTime,
      duration: totalHours * 60,
      amount: totalAmount,
      hallId: hallDetails.hallId,
      description: formData.description,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.hallBookingRequest,
      includeToken: true,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        getCartItems();
        setLoading(false);
        sethallDetails({
          capacity: "",
          minHours: "",
          minFee: "",
          setupAndCleaning: "",
          securityDeposit: "",
          cancellationFee: "",
          hourlyFee: 0,
          amount: 0,
          hallId: 0,
          defaultAmount: 0,
        });
        setFormData({
          name: getDevoteeId()?.userId || "",
          nameOfHall: "",
          noOfHours: "",
          date: "",
          description: "",
          hours: 0,
          minutes: 0,
          amount: 0,
          bookingTime: "",
        });
        setAmountBreakDown({
          securityDeposit: 0,
          setupAndCleaningFee: 0,
          totalHoursFee: 0
        })
        setIsHoursValid(true);
        setTotalAmount(0);
        setTotalHours(0);
        toast.custom(
          <SuccessPopup
            headerMessage="Items Added"
            showMessage={LOCALE.ITEM_ADDED}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        // toast.custom(<ToastSuccess message={LOCALE.ITEM_ADDED} />);
        navigate({
          pathname: window.location.pathname,
        });
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleAdd = async (e: any) => {
    e.preventDefault();
    const errors: ErrorMessageTypes = {
      name: "",
      nameOfHall: "",
      noOfHours: "",
      description: "",
      date: "",
      bookingTime: "",
      amount: "",
    };
    let donationAmountError = "";
    let bookingTimeError = errorMessage.bookingTime;

    if (totalAmount === 0) {
      donationAmountError = "Minimum donation amount is 1"
      setErrorMessage({
        ...errors,
        amount: "Minimum donation amount is 1",
        bookingTime: bookingTimeError,
      });
    } else {
      setErrorMessage({
        ...errors,
        bookingTime: bookingTimeError,
      });
      try {
        // Validate the form data against the validation schema
        await validationSchema.validate(formData, { abortEarly: false });

        setErrorMessage({...errors, bookingTime: bookingTimeError, amount: donationAmountError});
        if (!bookingTimeError && !donationAmountError) {
          if (isHallScheduled) {
            sendRequestApi();
          } else {
            setOpenConfirmationDialog(true);
          }
        }
      } catch (error) {
        // Handle validation errors
        if (error instanceof ValidationError) {
          error.inner.forEach((e) => {
            if (e.path) {
              errors[e.path as keyof ErrorMessageTypes] = e.message;
            }
          });
        }
        setErrorMessage({ ...errors, amount: donationAmountError });
      }
    }
  };

  const handleSetHallDetails = (selectedHall: any, money: number) => {
    // setTotalAmount(money);
    if (Number(hallId) !== selectedHall.id) {
      setTotalHours(selectedHall?.minimumHours);
    }
    sethallDetails({
      ...hallDetails,
      minHours: `${selectedHall?.minimumHours}Hrs`,
      capacity: `${selectedHall?.capacity}`,
      minFee: `${selectedHall?.minimumFee}`,
      setupAndCleaning: `${selectedHall?.setupAndCleaning}`,
      cancellationFee: `${selectedHall?.cancellationFee}`,
      securityDeposit: `${selectedHall?.securityDeposit}`,
      hourlyFee: selectedHall?.hourlyFee,
      amount: money,
      hallId: selectedHall.id,
      defaultAmount: money,
    });
  };

  useEffect(() => {
    const { selectedHall, money } =
      getHallAndAmountByHallId(formData.nameOfHall) || {};
    if (!isNil(selectedHall) && isNumber(money)) {
      setFormData({
        ...formData,
        minutes: 0,
        hours: selectedHall?.minimumHours,
      });
      handleSetHallDetails(selectedHall, money);
    }
  }, [formData.nameOfHall, hallList]);

  useEffect(() => {
    const { selectedHall, money } =
      getHallAndAmountByHallId(hallId, true) || {};
    if (!isNil(selectedHall) && isNumber(money)) {
      handleSetHallDetails(selectedHall, money);
    }
  }, [hallId, hallList]);

  useEffect(() => {
    if (formData.bookingTime) {
      handleHallTimeChangeSetErrors({
        ...constants.HALL_TIMINGS,
        formData,
        errorMessage,
        setErrorMessage,
        considerOnlyBookingTime: true,
      });
    }
  }, [formData.bookingTime, formData.hours, formData.minutes, formData.date]);

  useEffect(() => {
    const securityDeposit = Number(amountBreakDown?.securityDeposit) ?? 0.0;
    const setupAndCleaningFee = Number(amountBreakDown?.setupAndCleaningFee) ?? 0.0;
    const totalHoursFee =  Number(amountBreakDown?.totalHoursFee) ?? 0.0;;
    setTotalAmount(securityDeposit + setupAndCleaningFee + totalHoursFee);
  }, [amountBreakDown]);

  const handleFieldChange = (field: string, value: any) => {
    if (field === "nameOfHall") {
      setShowHallSchedule(true);
      setFormData({
        ...formData,
        [field]: value,
      });
      setErrorMessage({
        ...errorMessage,
        [field]: "",
        amount: "",
      });
    } else if (field === "date") {
      const formattedDate = dayjs(value, "MM-DD-YYYY");
      setFormData({
        ...formData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM-DD-YYYY")
          : "",
      });
      // sessionStorage.setItem("dateOfHall",formattedDate.isValid() ? formattedDate.format("MM-DD-YYYY") : "");
    } else if (field === "hours") {
      // const minHours = parseInt(hallDetails.minHours, 10) || 0;
      // if (value >= minHours) {
        const hourlyFee = hallDetails.hourlyFee || 0;
        const selectedHours =
          (parseInt(value, 10) || 0) +
          (parseInt(formData.minutes.toString(), 10) || 0) / 60;

        const securityDeposit = Number(amountBreakDown?.securityDeposit) ?? 0.0;
        const setupAndCleaningFee =
          Number(amountBreakDown?.setupAndCleaningFee) ?? 0.0;
        const amount =
          selectedHours * hourlyFee + securityDeposit + setupAndCleaningFee;

        setAmountBreakDown({
          ...amountBreakDown,
          totalHoursFee: selectedHours * hourlyFee,
        });

          setFormData({
            ...formData,
            [field]: value,
            noOfHours: `${value}:${formData.minutes}`,
          });
          setTotalHours(selectedHours);
    } else if (field === "minutes") {
      const selectedMinutes = parseInt(value, 10) || 0;
      const hours = parseInt(formData.hours.toString(), 10) || 0;
      const totalHours = hours + selectedMinutes/60;

      const securityDeposit = Number(amountBreakDown?.securityDeposit) ?? 0.0;
      const setupAndCleaningFee = Number(amountBreakDown?.setupAndCleaningFee) ?? 0.0;

      const amount =
        totalHours * hallDetails.hourlyFee +
        securityDeposit +
        setupAndCleaningFee;

      setAmountBreakDown({
        ...amountBreakDown,
        totalHoursFee: totalHours * hallDetails.hourlyFee,
      });
      setFormData({
        ...formData,
        [field]: value,
        noOfHours: `${formData.hours}:${value}`,
      });
      setTotalHours(totalHours);
    } else if (field === "bookingTime") {
      setFormData((prevItem) => ({ ...prevItem, [field]: value }));
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
      setErrorMessage({
        ...errorMessage,
        [field]: "",
      });
    }
  };

  const HallsDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Name of Hall"
          value={hallDetails.hallId}
          defaultValue=""
          id="nameOfHall"
          onChange={(e) => {
            handleFieldChange("nameOfHall", e.target.value);
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.nameOfHall ? styles.errorTextField : styles.textField
          }
        >
          {hallList.map((item: hallRentalListProps, index: number) => (
            <CustomMenuItem key={index} value={item.id}>
              {item.name}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.nameOfHall ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.nameOfHall}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const HoursDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          value={formData.hours}
          defaultValue=""
          id="hours"
          onChange={(e) => {
            handleFieldChange("hours", e.target.value);
            setErrorMessage({ ...errorMessage, noOfHours: "", amount: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.nameOfHall ? styles.errorTextField : styles.textField
          }
        >
          {hoursList.map((item, index: number) => (
            <CustomMenuItem key={index} value={item.label}>
              {item.label}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {/* {errorMessage.nameOfHall ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.nameOfHall}
          </Typography>
        ) : (
          ""
        )} */}
      </FormControl>
    );
  };

  const minutesDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          value={formData.minutes}
          defaultValue=""
          id="minutes"
          onChange={(e) => {
            handleFieldChange("minutes", e.target.value);
            setErrorMessage({ ...errorMessage, amount: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={styles.textField}
        >
          {minutesList.map((item, index: number) => (
            <CustomMenuItem key={index} value={item.label}>
              {item.label}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const [isDatePickerOpen, setDatePickerOpen] = useState(false);

  const handleDatePickerClick = () => {
    setDatePickerOpen(true);
  };

  useEffect(() => {
    setDatePickerOpen(false);
  }, [formData.date]);

  const BasicDatePicker = (): React.ReactElement => {
    return (
      <div>
        <StyledDateContainer onClick={handleDatePickerClick} id="bookingDate">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen}
                onClose={() => setDatePickerOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                disablePast
                shouldDisableDate={(date: unknown) => {
                  const currentDate = dayjs();
                  const dateAsDate = date as Date; // Type assertion
                  return dayjs(dateAsDate).isSame(currentDate, "day");
                }}
                format="MM-DD-YYYY"
                value={formData.date ? dayjs(formData.date, "MM-DD-YYYY") : ""}
                onChange={(value) => {
                  const selectedDate = dayjs(value as string, "MM-DD-YYYY");
                  const currentDate = dayjs(); // current date
                  if (selectedDate.isBefore(currentDate, "day")) {
                    setErrorMessage({
                      ...errorMessage,
                      date: "Please select a future date.",
                    });
                  } else {
                    // If the selected date is valid, update the state and clear error message
                    handleFieldChange("date", value);
                    setErrorMessage({ ...errorMessage, date: "" });
                  }
                }}
                className={
                  errorMessage.date ? styles.errorTextField : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.date ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.date}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleAgree = () => {
    setIsOpen(false);
  };

  const dialogPopup = () => {
    return (
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "504px",
            maxHeight: "240px",
            overflowY: "hidden",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        {/* <div className={styles.closeIcon} onClick={handleClose}>
          <CustomCloseIcon />
        </div> */}
        <DialogTitle className={commonStyles.dialogTitle}>
          {"Alert"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={commonStyles.dialogContext}
          >
            Requested number of hours for hall booking should be greater than or
            equal to suggested minimum number of hours.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          {/* <CommonOutlinedButton onClick={handleClose}>Cancel</CommonOutlinedButton> */}
          <CommonButton onClick={handleAgree}>Ok</CommonButton>
        </DialogActions>
      </Dialog>
    );
  };
  const navigateBack = () => {
    getCartItems();
  };

  const cartComponent = () => {
    return (
      <div>
        <div className={styles.backArrow} style={{ margin: "0px" }}>
          <div
            onClick={navigateBack}
            style={{
              marginRight: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <CustomLeftIcon />
          </div>
          <Typography className={styles.heading}>List of Item Added</Typography>
        </div>
        <ManagerCartItemsComponent navigateBack={navigateBack} />
      </div>
    );
  };

  const cartContainer = () => {
    return (
      <div className={styles.cartContainer}>
        <CommonOutlinedButton
          onClick={props.onBackClick}
          sx={{ marginTop: "10px", marginRight: "10px" }}
        >
          Back to Search Devotee
        </CommonOutlinedButton>
        <div className={styles.text}>Devotee Cart</div>
        <IconButton aria-label="cart" onClick={handleCart}>
          <CustomBadge badgeContent={cartItemsList.length} color="secondary">
            <img src={cartIcon} alt="cart Icon" />
          </CustomBadge>
        </IconButton>
      </div>
    );
  };

  const handleCart = (): void => {
    if (cartItemsList.length > 0) {
      setShowList(true);
    } else {
      setShowList(false);
    }
  };

  const getHallName = (hallId: number) => {
    const hallDetails = hallList.find((item: any) => item.id === hallId);

    return hallDetails?.name;
  };

  const onClickPriestSchedule = (hallId: number) => {
    if (
      formData.date === "" ||
      formData.bookingTime === "" ||
      formData.hours === 0 ||
      !getHallName(hallId)
    ) {
      alert("Please select Hall, Date, Time and hours");
    } else {
      const payload = {
        devoteeID: getDevoteeId().userId,
        hallName: getHallName(hallId),
        hallId: hallId,
        hallHours: formData.hours,
        hallmins: formData.minutes,
        halldesc: formData.description,
        hallAmount: totalAmount,
        date: formData.date,
        time: formData.bookingTime,
        isManagerRequest: true,
        poojaHallRequestsId: null,
        totalHoursFee: amountBreakDown.totalHoursFee,
        securityDeposit: amountBreakDown.securityDeposit,
        setupAndCleaningFee: amountBreakDown.setupAndCleaningFee,
      };
      dispatch(addHallBookingDetails(payload));
      props?.setShowHallScheduleScreen(true);
    }
  };

  const renderHallRental = () => {
    return (
      <div className={styles.HallRentalContainer}>
        <Typography component="div" className={styles.typoGraphyHeading}>
          Devotee Service
        </Typography>
        <Box>
          <Typography component="div" className={styles.typoGraphy}>
            Hall Rental
          </Typography>
          {cartContainer()}
        </Box>

        <form className={styles.formContainer} onSubmit={handleAdd}>
          <Card className={styles.cardContainer}>
            <div style={{ padding: "24px" }}>
              <Grid container spacing={2}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Name", true)}
                  <CustomTextFeild
                    id="name"
                    fullWidth
                    required
                    value={getDevoteeId()?.fullName?.toUpperCase()}
                    className={
                      errorMessage.name
                        ? styles.errorTextField
                        : styles.textField
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  {errorMessage.name ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.name}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Name of Hall", true)}
                  {HallsDropdown()}
                </Grid>
                {/* <Grid xs={12} sm={4} item>
                  {showHallSchedule ? (
                    <div
                      style={{
                        color: "blue",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => onClickPriestSchedule(hallDetails.hallId)}
                    >
                      See Hall schedule
                    </div>
                  ) : (
                    ""
                  )}
                </Grid> */}
                <div style={{ margin: "2px 0 0 17px" }}>
                  <span
                    style={{ width: "100%" }}
                    className={styles.hallInfotext}
                  >
                    Capacity : {hallDetails.capacity} | Min Hours:{" "}
                    {hallDetails.minHours} | Min Fee ${hallDetails.minFee} |
                    Hourly Fee ${hallDetails.hourlyFee} | Setup & Cleaning: $
                    {hallDetails.setupAndCleaning} | Security Deposit: $
                    {hallDetails.securityDeposit} | Cancellation Fee : $
                    {hallDetails.cancellationFee}
                  </span>
                </div>
              </Grid>

              <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Booking Date", true)}
                  {BasicDatePicker()}
                </Grid>
                <Grid xs={12} sm={4} item>
                  <HcccTimePicker
                    handleFieldChange={handleFieldChange}
                    labelName="Booking Time"
                    fieldName="bookingTime"
                    className={
                      errorMessage.bookingTime
                        ? styles.errorTextField
                        : styles.textField
                    }
                    value={formData.bookingTime}
                  />
                  {errorMessage.bookingTime ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.bookingTime}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                <Grid xs={12} sm={4} item id="numberOfHours">
                  {CustomRequiredInputLabel("Number of Hours", true)}
                  <div style={{ display: "flex", gap: "10px" }}>
                    {HoursDropdown()}{" "}
                    <div
                      style={{ marginTop: "auto", marginBottom: "auto" }}
                      id="hours"
                    >
                      Hr(s)
                    </div>
                    {minutesDropdown()}{" "}
                    <div
                      style={{ marginTop: "auto", marginBottom: "auto" }}
                      id="minutes"
                    >
                      Mins
                    </div>
                  </div>
                  {/* {errorMessage.noOfHours ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.noOfHours}
                  </Typography>
                ) : (
                  ""
                )} */}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Security Deposit", true)}
                  <CustomTextFeild
                    id="securityDeposit"
                    fullWidth
                    required
                    value={amountBreakDown?.securityDeposit}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoneyIcon
                            fontSize="small"
                            sx={{ position: "absolute" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => {
                      const inputValue = e.target.value.trim(); // Trim whitespace
                      const newValue = inputValue.slice(0, 10);
                      if (newValue === "") {
                        setAmountBreakDown({
                          ...amountBreakDown,
                          securityDeposit: "",
                        });
                      } else if (/^\d*\.?\d*$/.test(newValue)) {
                        setAmountBreakDown({
                          ...amountBreakDown,
                          securityDeposit: newValue,
                        });
                      }
                    }}
                    onBlur={(e) => {
                      const value = e.target.value;
                      if (value === "") {
                        setAmountBreakDown({
                          ...amountBreakDown,
                          securityDeposit: 0,
                        });
                      }
                    }}
                    className={styles.textField}
                    placeholder="Security deposit"
                  />
                </Grid>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Setup & Cleaning Fee", true)}
                  <CustomTextFeild
                    id="setupAndCleaning"
                    fullWidth
                    required
                    value={amountBreakDown?.setupAndCleaningFee}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoneyIcon
                            fontSize="small"
                            sx={{ position: "absolute" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => {
                      const inputValue = e.target.value.trim(); // Trim whitespace
                      const newValue = inputValue.slice(0, 10);
                      if (newValue === "") {
                        setAmountBreakDown({
                          ...amountBreakDown,
                          setupAndCleaningFee: "",
                        });
                      } else if (/^\d*\.?\d*$/.test(newValue)) {
                        setAmountBreakDown({
                          ...amountBreakDown,
                          setupAndCleaningFee: newValue,
                        });
                      }
                    }}
                    onBlur={(e) => {
                      const value = e.target.value;
                      if (value === "") {
                        setAmountBreakDown({
                          ...amountBreakDown,
                          setupAndCleaningFee: 0,
                        });
                      }
                    }}
                    className={styles.textField}
                    placeholder="Setup and cleaning fee"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Hall Rent", true)}
                  <CustomTextFeild
                    id="hallRent"
                    fullWidth
                    required
                    value={amountBreakDown?.totalHoursFee}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoneyIcon
                            fontSize="small"
                            sx={{ position: "absolute" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => {
                      const inputValue = e.target.value.trim(); // Trim whitespace
                      const newValue = inputValue.slice(0, 10);
                      if (newValue === "") {
                        setAmountBreakDown({
                          ...amountBreakDown,
                          totalHoursFee: "",
                        });
                      } else if (/^\d*\.?\d*$/.test(newValue)) {
                        setAmountBreakDown({
                          ...amountBreakDown,
                          totalHoursFee: newValue,
                        });
                      }
                    }}
                    onBlur={(e) => {
                      const value = e.target.value;
                      if (value === "") {
                        setAmountBreakDown({
                          ...amountBreakDown,
                          totalHoursFee: 0,
                        });
                      }
                    }}
                    className={styles.textField}
                    placeholder="Hall rent"
                  />
                </Grid>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Total Tangible Amount", true)}
                  <CustomTextFeild
                    id="suggestedAmount"
                    fullWidth
                    required
                    value={totalAmount}
                    disabled
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoneyIcon
                            fontSize="small"
                            sx={{ position: "absolute" }}
                          />
                        </InputAdornment>
                      ),
                      readOnly: true,
                    }}
                    onChange={(e) => {
                      const inputValue = e.target.value.trim(); // Trim whitespace
                      const newValue = inputValue.slice(0, 10);
                      if (newValue === "") {
                        setTotalAmount(""); // Clear the total amount if input is empty
                      } else {
                        setTotalAmount(
                          newValue.replace(/[^\d.]*\.[^\d.]*/g, "")
                        );
                        setErrorMessage({ ...errorMessage, amount: "" });
                      }
                    }}
                    className={styles.textField}
                    placeholder="Tangible amount"
                  />
                  {errorMessage.amount ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.amount}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Grid xs={30} sm={13} item sx={{ marginTop: "15px" }}>
                {CustomRequiredInputLabel("Description", true)}
                <textarea
                  id="description"
                  style={{ height: "89px", width: "65%" }}
                  required
                  onChange={(e) => {
                    handleFieldChange("description", e.target.value);
                    setErrorMessage({ ...errorMessage, description: "" });
                  }}
                  value={formData.description}
                  className={
                    errorMessage.nameOfHall
                      ? styles.errorTextField
                      : styles.textField
                  }
                />
                {errorMessage.description ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.description}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
            </div>
          </Card>
          <CommonButton
            sx={{ mt: "10px", mr: "20px" }}
            onClick={() =>
              errorMessage.bookingTime ||
              onClickPriestSchedule(hallDetails.hallId)
            }
            id="schedule_hall"
            type="submit"
          >
            Schedule Hall
          </CommonButton>
          <CommonButton
            sx={{ marginTop: "10px" }}
            onClick={handleAdd}
            disabled={loading}
            id="add"
            type="submit"
          >
            <ButtonLoader isBtnLoading={loading} btnText={"Add"} />
          </CommonButton>
        </form>
      </div>
    );
  };
  return (
    <>
      {dialogPopup()}
      <Toaster /> {!showList ? renderHallRental() : cartComponent()}
      {openConfirmationDialog && (
        <ConfirmationDialog
          title={"Please confirm"}
          description={
            "You haven't scheduled a hall. Are you sure you want to add this to the cart?"
          }
          handleProceed={sendRequestApi}
          handleClose={() => setOpenConfirmationDialog(false)}
          open={openConfirmationDialog}
        />
      )}
    </>
  );
};
export default DevoteeHallBooking;
